<div class="min-h-screen flex flex-col justify-center items-center">
    <router-outlet></router-outlet>
</div>
